
webpack.register(
    'modules/player-statistics/player-statistics',
    function() {
        return import('modules/player-statistics/player-statistics');
    },
    true
);